export type SubmittedSearchEvent = {
    event: 'submitted_search';
    search_term: string;
};

export const trackSubmittedSearchEvent = (query: string): SubmittedSearchEvent => ({
    event: 'submitted_search',
    search_term: query
});
